"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResourceProvider = void 0;
class ResourceProvider {
    constructor(apiClient, defaultNamespace, resourceApi) {
        this.keyedResources = {};
        this.getText = (code, defValue, namespace) => {
            const key = (namespace ? namespace : this.defaultNamespace) + '.' + code;
            const item = this.keyedResources[key];
            return item ? item.value : defValue || `#${code}`;
        };
        this.loadResources = () => this.apiClient.callApi('GET', this.resourceApi)
            .then(this.resolveResources);
        this.resolveResources = (resources) => {
            if (resources) {
                resources.forEach(namespace => {
                    namespace.translations.forEach(translation => {
                        if (this.keyedResources[namespace.name + '.' + translation.key] === undefined) {
                            this.keyedResources[namespace.name + '.' + translation.key] = translation;
                        }
                    });
                });
            }
        };
        this.apiClient = apiClient;
        this.defaultNamespace = defaultNamespace;
        this.resourceApi = resourceApi;
        this.keyedResources = {};
    }
}
exports.ResourceProvider = ResourceProvider;
